import { render, staticRenderFns } from "./PaymentMethodIcon.vue?vue&type=template&id=214f22bc&scoped=true"
import script from "./PaymentMethodIcon.vue?vue&type=script&lang=js"
export * from "./PaymentMethodIcon.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethodIcon.vue?vue&type=style&index=0&id=214f22bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214f22bc",
  null
  
)

export default component.exports